import React from "react";
import Loadable from "react-loadable";
import { Switch, Route } from "react-router-dom";
import { NotFound } from "~/views/Errors";
import LoadingSpinner from "~/components/LoadingSpinner";

const ReportsView = Loadable({
    loader: () => import("~/views/admin/systemreports"),
    loading: LoadingSpinner
});

export default ({ match }) => (
    <Switch>
        <Route path={`${match.url}/`} component={ReportsView} />
        <Route component={NotFound} />
    </Switch>
);
